import ContributionItemModelBase from '../_generated/modelBases/contribution-item-model-base';

export default class ContributionItemModel extends ContributionItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
